<template lang="html">
  <div class="home-wrapper">
    <!-- <div class="msg-bg">
      <div class="msg">
        <p>{{title}}</p>
        <p>欢迎您回来</p>
      </div>
      <img :src="homeGif" alt="">
    </div> -->
    <div  v-if="permission" class="home-content">
    <!-- <div class="home-content"> -->
      <div class="content">
        <p class="content-title">应用 <span>Application</span></p>
        <div class="application-container container">
          <!-- <el-card v-for="(item, index) in application" :key="index" shadow="hover" @mouseenter="onMousteIn(index)"
            @mouseleave="onMousteOut()"> -->
          <div v-for="(item, index) in showProject" :key="index" class="card-item"
            @mouseenter="mousemove(index, 'seen', 'current')" @mouseleave="mouseleave('seen', 'current')" @click="clickApps(item, index)" :class="{ active: isActive && index === isAC, disabledcard: item.add }" >
            <div class="head">
              <div v-if="item.add">
                <img class="add-apps" :src="addImg" alt="">
              </div>
              <p class="application-name">{{item.name}}</p>
            </div>
            <!--  -->
            <div class="operate-btn options" v-if="!item.add">
              <el-button type="text" icon="el-icon-delete" v-show="seen && index === current" v-if="item.edit" @click="cDeleteProject(item)"></el-button>
              <el-button type="text" icon="el-icon-tickets" v-show="seen && index === current" v-if="item.edit" @click="clickApps(item, index, 'edit')"></el-button>
              <el-button type="text" icon="el-icon-back" v-show="seen && index === current"  v-if="item.getInto" @click="accessApplication(item)" class="get-into">进入</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <p class="content-title">应用功能 <span>Application Function</span></p>
        <div class="model-container container">
          <div v-for="(item, index) in showModule" :key="item.name" shadow="hover" class="card-item" :class="{ disabledcard: !item.getInto }"
          @mouseenter="mousemove(index, 'mSeen', 'mCurrent')" @mouseleave="mouseleave('mSeen', 'mCurrent')">
            <div class="head">
              <i :class="item.icon" class="iconfont "></i>
              <p>{{item.name}}</p>
            </div>
            <div class="options operate-btn" v-if="item.getInto">
              <el-popover placement="top" width="200" trigger="click" v-model="item.isEdit" @show="clickMEdit(item)" @hide="hideMEdit(item)">
                <el-form :model="moduleName">
                  <el-form-item label="应用功能名称">
                    <el-input v-model="moduleName.name" placeholder="请输入应用功能名称"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="editModuleName(item)">确 定</el-button>
                    <el-button type="info" @click="item.isEdit = false">取 消</el-button>
                  </el-form-item>
                </el-form>
                <el-button slot="reference" type="text" icon="el-icon-edit"  v-if="item.edit && item.getInto"
                  v-show="mSeen && index === mCurrent" class="edit"></el-button>
              </el-popover>
              <el-button type="text" icon="el-icon-back" class="get-into" v-if="item.getInto"
                v-show="mSeen && index === mCurrent" @click="clickModule(item)">进入</el-button>
            </div>
            <!-- <el-button type="text" icon="el-icon-edit" v-if="item.edit" v-show="mSeen && index === mCurrent"></el-button> -->
          </div>
          <!-- <div v-if="showModule.length === 0">
            <p class="module-msg-info">该应用下还没有选择应用功能，请编辑应用选择</p>
          </div> -->
          <!-- <el-button v-if="isActive && isAC !== null" class="module-msg-btn" type="primary" plain @click="viewModule">全部应用功能</el-button> -->
        </div>
      </div>

      <div>
        <div class="content">
          <p class="content-title">平台产品  <span>Platform products</span></p>
          <div class="service-container container">
            <div class="title-box">
              <p class="two-title">设备数据接入</p>
            </div>
            <div v-for="(item, index) in serviceList" :key="item.name" shadow="hover" class="card-item"
              @mouseenter="mousemove(index, 'sSeen', 'sCurrent')" @mouseleave="mouseleave('sSeen', 'sCurrent')"
              @click="clickService(item)" :class="{ disabledcard: item.disabled }">
              <div class="head">
                <i :class="item.icon" class="iconfont "></i>
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>

          <div class="service-container container">
            <div class="title-box">
              <p class="two-title">数据处理</p>
            </div>
            <div v-for="(item, index) in serviceHandle" :key="item.name" shadow="hover" class="card-item"
              @mouseenter="mousemove(index, 'sSeen', 'sCurrent')" @mouseleave="mouseleave('sSeen', 'sCurrent')"
              @click="clickService(item)" :class="{ disabledcard: item.disabled }">
              <div class="head">
                <i :class="item.icon" class="iconfont "></i>
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>

          <div class="service-container container">
            <div class="title-box">
              <p class="two-title">数据存储</p>
            </div>
            <div v-for="(item, index) in saveService" :key="item.name" shadow="hover" class="card-item"
              @mouseenter="mousemove(index, 'sSeen', 'sCurrent')" @mouseleave="mouseleave('sSeen', 'sCurrent')"
              @click="clickService(item)" :class="{ disabledcard: item.disabled }">
              <div class="head">
                <i :class="item.icon" class="iconfont "></i>
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>

          <div class="service-container container">
            <div class="title-box">
              <p class="two-title">可视化</p>
            </div>
            <div v-for="(item, index) in visualization" :key="item.name" shadow="hover" class="card-item"
              @mouseenter="mousemove(index, 'sSeen', 'sCurrent')" @mouseleave="mouseleave('sSeen', 'sCurrent')"
              @click="clickService(item)" :class="{ disabledcard: item.disabled }">
              <div class="head">
                <i :class="item.icon" class="iconfont "></i>
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>

          <div class="service-container container">
            <div class="title-box">
              <p class="two-title">开放接口</p>
            </div>
            <div v-for="(item, index) in openApi" :key="item.name" shadow="hover" class="card-item"
              @mouseenter="mousemove(index, 'sSeen', 'sCurrent')" @mouseleave="mouseleave('sSeen', 'sCurrent')"
              @click="clickService(item)" :class="{ disabledcard: item.disabled }">
              <div class="head">
                <i :class="item.icon" class="iconfont "></i>
                <p>{{item.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <appsDialog v-if="tempAppsInfo.dialogVisible" :tempAppsInfo="tempAppsInfo" :projectInfo="projectInfo"></appsDialog>

      <projectDialog :temp="temp" :projectData="projectInfo.projectData" ></projectDialog>
    </div>
    <showPanel v-else :projectInfo="projectInfo" :showProject="showProject"></showPanel>
  </div>
</template>

<script>
import project1 from '@/assets/icons/project1.png'
import project2 from '@/assets/icons/project2.png'
import project3 from '@/assets/icons/project3.png'
import project4 from '@/assets/icons/project4.png'
import addPng from '@/assets/icons/add.png'
import addBPng from '@/assets/icons/add-b.png' // 白主题暂缺
// import homeBg from '@/assets/other/home-bg.png'
import Cookies from 'js-cookie'
// import Cookies from 'js-cookie'
import appsDialog from './components/appsDialog.vue'
import projectDialog from './components/projectDialog.vue'
import showPanel from './components/showPanel.vue'
import { getTenantProject, getModule, getProjectModule, getProjectMenu, editModuleName, deleteProject, getUserProject } from '@/api/project-controller'
import { getRolePMenu } from '@/api/menu-controller'
import { getAttributes } from '@/api/telemetry-controller'
import { getTenantGateway } from '@/api/device-controller'
import { filterAsyncRouter } from '@/utils/RouterMenu'
// import { menuRouterHandle } from '@/utils/projectRouterPath'
import { removeSlash } from '@/utils/removeIdSlash.js'

export default {
  name: 'Home',
  inject: ['reload'],
  components: {
    appsDialog,
    projectDialog,
    showPanel
  },
  data: function () {
    return {
      // title: '',
      that: this,
      addPng: addPng,
      addBPng: addBPng,
      isActive: false,
      isAC: null,
      seen: false,
      mSeen: false,
      sSeen: false,
      current: null,
      mCurrent: null,
      sCurrent: null,
      permission: false,
      projectInfo: {
        projectModule: [], // 企业全部模块
        tempPModule: [],
        projectData: [], // 企业全部应用
        tenantGateway: []
      },
      // 模块
      // projectModule: [], // 企业全部模块
      showModule: [], // 当前显示模块
      // tempPModule: [],
      projectM: new Map(),
      moduleName: {
        name: ''
      },
      tempModule: {
        name: '',
        id: ''
      },
      // 应用
      tempAppsInfo: {
        dialogVisible: false // 编辑
      },
      temp: {
        title: '',
        email: '',
        phone: '',
        country: '',
        state: '',
        city: '',
        address: '',
        zip: '',
        region: '',
        dialogVisible: false // 新增
      },
      projectNumber: 3,
      initialApplication: {
        name: '添加应用',
        // path: '/home/transition', // 进系统后显示界面
        add: true,
        edit: true,
        module: [] // 就是首页下的模块 menuModule
      },
      // projectDatas: new Map(),
      showProject: [],
      projectModuleList: {},
      // 服务
      serviceList: [
        {
          name: '设备接入',
          path: '/deviceManage/index',
          disabled: false,
          showInfo: '接入设备添加，操作等相关配置，点击可直接进入',
          icon: 'p-icon-Nav-shebeijieru'
        }, {
          name: '网关配置',
          path: '/EXTgatewayManageV2/index',
          disabled: false,
          showInfo: '网关配置，可进行挂载设备设置等，点击可直接进入',
          icon: 'p-icon-wangguanpeizhi'
        }, {
          name: '设备协议配置',
          path: '/deviceProtocol/index',
          disabled: false,
          showInfo: '设备协议具体配置，点击可直接进入',
          icon: 'p-icon-chanpinxieyipeizhi'
        }
      ],
      serviceHandle: [
        {
          name: '规则引擎',
          path: '/rulechain/index',
          disabled: false,
          icon: 'p-icon-guize'
        }, {
          name: '流计算引擎',
          path: '/rulechain/index',
          disabled: true,
          icon: 'p-icon-liujisuan1'
        }
      ],
      saveService: [
        {
          name: 'openTSDB 时序数据库',
          path: 'http://47.105.216.189:4242/',
          disabled: false,
          openInNewTab: true,
          icon: 'p-icon-shixushujukuTSDS'
        }, {
          name: 'influxDB 时序数据库',
          path: '/rulechain/index',
          disabled: true,
          icon: 'p-icon-shixushujukuTSDS'
        }
      ],
      visualization: [
        {
          name: 'BI 可视化工具',
          path: `http://fes.natsuki.cc:8022/login?email=${Cookies.get('Email')}&password=${Cookies.get('Password')}`,
          disabled: false,
          openInNewTab: true,
          icon: 'p-icon-keshihua'
        }
        // {
        //   name: '地理信息可视化',
        //   path: '/3dgis/index',
        //   disabled: false,
        //   icon: 'p-icon-dilixinxixitong'
        // }
      ],
      openApi: [
        {
          name: 'API 接口',
          path: '/platformPage/apiHtml',
          disabled: false,
          icon: 'p-icon-jiance1'
        }, {
          name: 'swagger 调试工具',
          path: 'http://47.105.216.189:8081/swagger-ui.html',
          disabled: false,
          openInNewTab: true,
          icon: 'p-icon-tiaoshigongju'
        }
      ],
      projectIcon: [
        project1, project2, project3, project4
      ]
    }
  },
  created () {
    this.isActive = false
    this.isAC = null
    this.seen = false
    this.mSeen = false
    this.sSeen = false
    this.current = null
    this.mCurrent = null
    this.sCurrent = null
    this.permission = false
    // 判断是否是总管理员
    const roles = this.$store.state.user.roles && this.$store.state.user.roles.length > 0
    if (roles && this.$store.state.user.roles[0] === 'SYS_ADMIN') {
      // 总管理员 直接跳转系统内 到过渡页
      this.$router.push('/tenant/index')
    } else {
      if (this.$store.state.user.roles[0] !== 'TENANT_SYS') {
        this.serviceList.forEach(v => {
          v.disabled = false
        })
      }
    }
    // 获取普通登录用户的应用权限
    // getUserProject().then(res =>{
    //   console.log(res, '-----up')
    // })
    // else if () {
    // --------还有一个账户是直接跳转内部的------
    // 登录账户权限判断
    // }

    // console.log(this.$store.state, '---登录用户')
    // 是否有 模块 应用 更改权限
    if (roles && (this.$store.state.user.roles[0] === 'TENANT_SYS' || (this.$store.state.user.roles[1] && this.$store.state.user.roles[1] === 'TENANT_SYS'))) {
      this.permission = true
    }
    if (this.permission) {
      // 最大应用添加数
      getAttributes('TENANT', this.$store.state.user.tenantId).then(res => {
        for (const item of res.data) {
          if (item.key === 'createProjectLimit') {
            this.projectNumber = item.value
          }
          if (item.key === 'readMeterTime' || item.key === 'photoPath') {
            this.tempAppsInfo.readMeterTime = item.value
          }
          if (item.key === 'alarmTime') {
            this.tempAppsInfo.alarmTime = item.value
          }
        }
        // get 应用 Project
        getTenantProject().then(res => {
          this.showProject = []
          this.projectInfo.projectData = []
          if (res.data.length === 0) {
            this.showProject.push(this.initialApplication)
          } else {
            for (const item of res.data) {
              item.edit = this.permission
              item.getInto = true
              // this.projectDatas.set(item.id.id, item)
              this.projectInfo.projectData.push(item)
            }
            console.log(this.projectInfo, '---处理信息 应用 模块 网关')
            if (this.projectNumber > this.projectInfo.projectData.length) {
              this.showProject = this.projectInfo.projectData.filter(v => v)
              this.showProject.push(this.initialApplication)
            } else {
              this.showProject = this.projectInfo.projectData.filter(v => v)
            }
            // -----------------------------------要删除的
            this.showProject.forEach((item, i) => {
              if (i <= 3) {
                item.pIcon = this.projectIcon[i]
              } else if (i <= 7) {
                item.pIcon = this.projectIcon[i - 4]
              }
            })
          }
        })
      })
      // get 所有模块 Module
      getModule().then(res => {
        for (const item of res.data) {
          const info = JSON.parse(item.route)
          item.component = info.component
          item.names = info.name
          item.path = info.path
          item.edit = this.permission
          item.isEdit = false
          this.projectInfo.projectModule.push(item)
          this.projectM.set(item.id, item)
        }
        this.showModule = this.projectInfo.projectModule
      })
      // get 所有 网关
      getTenantGateway().then(res => {
        for (const item of res.data) {
          this.projectInfo.tenantGateway.push(item)
        }
      })
    } else {
      // 普通用户 无权限
      getUserProject().then(res => {
        this.showProject = []
        this.projectInfo.projectData = []
        if (res.data.length === 0) {
          this.showProject.push({
            name: '账号无应用权限',
            // path: '/home/transition',
            add: false,
            edit: false,
            module: []
          })
        } else {
          for (const item of res.data) {
            item.edit = this.permission
            item.getInto = true
            // this.projectDatas.set(item.id.id, item)
            this.projectInfo.projectData.push(item)
          }
          this.showProject = this.projectInfo.projectData.filter(v => v)
          this.showProject.forEach((item, i) => {
            if (i <= 3) {
              item.pIcon = this.projectIcon[i]
            } else if (i <= 7) {
              item.pIcon = this.projectIcon[i - 4]
            }
          })
        }
      })
      this.serviceList.forEach(v => {
        v.disabled = true
      })
      this.serviceHandle.forEach(v => {
        v.disabled = true
      })
      this.saveService.forEach(v => {
        v.disabled = true
      })
      this.visualization.forEach(v => {
        v.disabled = true
      })
      this.openApi.forEach(v => {
        v.disabled = true
      })
    }
  },
  mounted () {
  },
  methods: {
    accessApplication (info, modules) {
      // projectRouterPath(info, this)
      // let pagePush = '/home/transition'
      // let pagePush = ''
      // if (modules) {
      //   pagePush = modules
      // }
      if (this.permission) {
        getProjectMenu(info.id.id).then(res => {
          console.log(res.data, '获取应用菜单')
          this.getIntoSystem(res.data, info, modules)
        })
      } else {
        getRolePMenu(info.id.id).then(res => {
          console.log(res, '------getRolePMenu')
          this.getIntoSystem(res.data, info, modules)
        })
      }
    },
    getIntoSystem (data, info, modules) {
      let pagePush = ''
      console.log(data, info, modules, '------------')
      if (data.length > 0) {
        this.$store.dispatch('untreatedPRouter', data)
        const getRouter = filterAsyncRouter(data)
        // 保存应用 路由的信息到 store
        this.$store.dispatch('ChangeProject', info)
        this.$store.dispatch('addPRoutes', { getRouter })
        this.$router.addRoutes(getRouter)
        if (modules) {
          pagePush = modules
        } else {
          // 默认进第一个
          pagePush = getRouter[0].path
          if (getRouter[0].children && getRouter[0].children.length > 0) {
            const path = getRouter[0].children[0].path
            if (path.substr(0, 1) === '/') {
              pagePush = path
            } else {
              pagePush += '/' + path
            }
          }
        }
        console.log(pagePush, '----进的路径')
        this.$router.push(pagePush)
      } else {
        this.$message('当前应用下无应用功能，不可进入')
      }
    },
    clickApps (info, index, e) {
      if (info.add) {
        // 进添加页
        this.temp.dialogVisible = true
        this.viewModule()
      } else {
        if (info.edit && e && e === 'edit') {
          // 进编辑
          this.tempAppsInfo.data = info
          this.tempAppsInfo.dialogVisible = true
        } else {
          this.isActive = true
          this.isAC = index
        }
        // 展示p已有模块 避免重复调api查模块，保存在this.projectModuleList里 reload为编辑了模块名称的情况 重新获取一次
        this.projectInfo.tempPModule = []
        this.showModule = []
        if (e && e === 'reload') {
          getProjectModule(info.id.id).then(res => {
            this.projectModuleList[info.id.id] = []
            for (const item of res.data) {
              const routes = JSON.parse(item.route)
              item.component = routes.component
              item.names = routes.name
              item.path = routes.path
              item.edit = this.permission
              item.isEdit = false
              item.getInto = true
              item.project = info
              item.projectIndex = index
              this.showModule.push(item)
              this.projectModuleList[info.id.id].push(item)
            }
          })
        } else {
          if (this.projectModuleList[info.id.id]) {
            this.showModule = this.projectModuleList[info.id.id]
          } else {
            getProjectModule(info.id.id).then(res => {
              this.projectModuleList[info.id.id] = []
              for (const item of res.data) {
                const routes = JSON.parse(item.route)
                item.component = routes.component
                item.names = routes.name
                item.path = routes.path
                item.edit = this.permission
                item.isEdit = false
                item.getInto = true
                item.project = info
                item.projectIndex = index
                this.showModule.push(item)
                this.projectModuleList[info.id.id].push(item)
              }
            })
          }
        }
        this.projectInfo.tempPModule = this.showModule
      }
    },
    cDeleteProject (info) {
      this.$confirm('此操作将永久删除该应用, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteProject(removeSlash(info.id.id)).then(res => {
          this.messageInfo('success', '删除成功')
          this.reload()
        })
      }).catch(() => {
        //
      })
    },

    // ---------------- 模 块 ------------------------

    viewModule () {
      this.showModule = this.projectInfo.projectModule.filter(v => {
        v.getInto = false
        return v
      })
      this.isActive = false
      this.isAC = null
    },
    clickMEdit (info) {
      this.tempModule.name = info.name
      this.tempModule.id = info.id
      this.moduleName.name = info.name
      info.isEdit = true
    },
    hideMEdit (info) {
      info.isEdit = false
    },
    editModuleName (info) {
      this.moduleName.name = this.moduleName.name.trim()
      if (this.moduleName.name.length > 7 || this.moduleName.name.length === 0) {
        this.$message('应用功能名称不可为空 不可超过7位')
        return false
      }
      for (const v of this.showModule) {
        if (v.id !== this.tempModule.id && v.name === this.moduleName.name) {
          this.$message('保存失败，应用功能名称不可重复')
          return false
        }
      }
      const params = {
        projectId: info.project.id.id,
        moduleId: this.tempModule.id,
        data: {
          name: this.moduleName.name
        }
      }
      editModuleName(params).then(res => {
        this.messageInfo('success', '应用功能名称 修改成功')
        this.clickApps(info.project, info.projectIndex, 'reload')
      })
    },
    clickModule (info) {
      if (info.getInto && !info.isEdit) {
        let paths = info.path
        if (info.child && info.child.length > 0) {
          const routes = JSON.parse(info.child[0].route)
          if (routes.path[0] === '/') {
            paths = routes.path
          } else {
            paths += '/' + routes.path
          }
          // if (routes.path.split('/').length > 1) {
          //   paths +=  routes.path
          // } else {
          //   paths += '/' + routes.path
          // }
        }
        this.accessApplication(info.project, paths)
      } else {
        return false
      }
    },
    clickService (info) {
      if (info.disabled) {
        // this.$message('您没有进入权限，请切换平台管理员账号查看')

      } else {
        if (info.openInNewTab) {
          window.open(info.path, '_blank')
          return
        }
        this.$router.push(info.path)
      }
    },
    mousemove (index, seen, current) {
      this[seen] = true // 鼠标移入显示
      this[current] = index
    },
    mouseleave (seen, current) {
      this[seen] = false // 鼠标移出隐藏
      this[current] = null
    },
    messageInfo (type, info) {
      this.$message({
        type: type,
        message: info
      })
    }
  },
  computed: {
    addImg () {
      return this.$store.state.app.theme === '252C47' ? this.addPng : this.addBPng
    }
  }
}
</script>

<style lang="scss">
// @import url('src/assets/other/home-bg.png');
.home-wrapper {
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: 100%;
  // padding: 20px;
  padding: 20px 0;
  // background: url('~@/assets/other/home-bg.png') center center no-repeat;
  // margin: 0 auto;
  .home-content {
    width: 80%;
    min-width: 1220px;
    margin: 0 auto;
  }
  .content {
    margin-bottom: 20px;
    // padding: 15px;
    p {
      margin: 0 0;
    }
    .content-title {
      margin: 0 0 10px 28px;
      color: #dedfe3;
      font-family: '隶书';
      font-size: 22px;
    }
    .module-msg-info {
      margin: 10px 15px;
    }
    .module-msg-btn {
      margin: 15px;
    }
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    font-family: '黑体';
    .card-item {
      &:hover {
        cursor: pointer;
      }
      display: flex;
      justify-content: space-between;
      margin: 15px 28px;
      // padding: 20px;
      border-radius: 5px;
      .head {
        // padding: 20px;
        // display: inline-block;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 26px;
          margin: 0 10px;
          color: #72ddff;
        }
      }
      .options {
        display: inline-block;
        border-radius: 0 5px 5px 0;
      }
    }
    .disabledcard {
      background: #10172f;
    }
  }

  .application-container {
    .card-item {
      min-width: 300px;
      height: 80px;
      .add-apps {
        width: 40px;
        margin: 20px 10px;
      }
    }
    // .addproject {
    //   background: #10172f;
    // }
    .active {
      // border-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(253, 253, 253, 0.25);
    }
    .application-name {
      font-size: 24px;
    }
    .operate-btn {
      // margin-top: -20px;
      // margin-right: -20px;
      width: 68px;
      padding: 0 10px 0 5px;
      // height: 80px;
      // padding-left: 9px;
      // background: rgba(75, 75, 183, 0.28);
      display: flex;
      flex-wrap: wrap;
      .get-into {
        margin-left: 0px;
      }
    }
  }
  .model-container {
    min-height: 90px;
    .card-item {
      width: 210px;
      height: 60px;
      min-width: 150px;
      margin: 15px 28px;
      margin: 15px 17px;
      background-color: #10172f;
      .el-button--text {
        margin-left: 10px;
      }
      p {
        margin-left: 10px;
      }
      .operate-btn {
        width: 58px;
        display: flex;
        flex-wrap: wrap;
        // padding: 0 6px;
        padding-right: 10px;
        justify-content: space-around;
      }
      .get-into, .edit {
        margin-left: 0;
        padding: 3px;
      }
      .edit {
        margin-top: 5px;
      }
    }
    .isclick {
      background-color: #3a435a;
    }
  }
  .service-container {
    background-color: #101630;
    margin: 15px 15px;
    padding: 10px;
    .title-box {
      width: 100px;
      margin-left: 10px;
      .two-title {
        margin: 30px 0;
        font-size: 16px;
        color: #949496;
      }
    }
    .card-item {
      width: 240px;
      height: 60px;
      .el-button--text {
        margin-left: 10px;
      }
    }
  }

  // .search-bar {
  //   margin-bottom: 10px;
  // }

  // .card-list {
  //   .chart-line {
  //     display: flex;
  //     margin: 0 -10px;
  //     * {
  //       margin: 0 10px;
  //       flex: auto;
  //     }
  //   }
  // }
  // .chart-line-warpper {
  //   margin-bottom: 10px;
  //   width: 100%;
  //   .lineChart {
  //     width: 100%;
  //     .echarts {
  //       width: 100%;
  //       height: 500px;
  //     }
  //   }
  // }

  // .col-2 {
  //   width: 100%;
  //   .chart-line {
  //     width: 100%;
  //     .barChart {
  //       margin-right: 10px;
  //     }
  //     * {
  //       float: left;
  //       width: calc(50% - 5px);
  //       .echarts {
  //         width: 100%;
  //       }
  //     }
  //   }
  // }
  // .msg-bg {
  //   display: flex;
  //   justify-content: center;
  //   .msg {
  //     font-size: 36px;
  //     margin: 10% auto;
  //     text-align: center;
  //     color: #34465d;
  //   }
  // }
}

</style>
